import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RecoverForm } from "@/features/auth/components/RecoverForm";
import { Stack } from "@mui/material";
import { FC } from "react";

type TRecoverPageProps = {};

export const RecoverPage: FC<TRecoverPageProps> = () => {
  return (
    <Stack gap="50px" alignItems="center">
      <LoginLogo />
      <RecoverForm />
    </Stack>
  );
};
